module.exports = __webpack_public_path__ + "static/media/charles32.22b70e33.png";